module.exports = __webpack_public_path__ + "media/newstyle/images/icon-export-f2ffed0b6d1d082b0c604d743d33c736.svg";